import _extends from "@babel/runtime/helpers/extends";
/**
 * 基于axios实现的菜鸟基础request库
 * axios介绍：https://axios-http.com/zh/docs/intro
 */
import axios from 'axios';
import { isUndefined, armsTraceLog, mergeReportData } from "./utils";
import errorFeedbackInterceptor from "./interceptors/error-feedback";
var LEGAL_METHODS = ['GET', 'POST'];
var _window = window;
_window.__cn_request_config = _window.__cn_request_config || {
  cnOptions: {
    armsTrace: null
  },
  axiosConfig: {}
};
_window.__cn_request_instance = _window.__cn_request_instance || {
  request: null,
  reInit: function reInit(config) {
    var _config$cnOptions = config.cnOptions,
      cnOptions = _config$cnOptions === void 0 ? {} : _config$cnOptions,
      _config$axiosConfig = config.axiosConfig,
      axiosConfig = _config$axiosConfig === void 0 ? {} : _config$axiosConfig,
      _config$reset = config.reset,
      reset = _config$reset === void 0 ? false : _config$reset;
    if (reset) {
      _window.__cn_request_config.cnOptions = cnOptions;
      _window.__cn_request_config.axiosConfig = axiosConfig;
    } else {
      _window.__cn_request_config.cnOptions = _extends({}, _window.__cn_request_config.cnOptions, cnOptions);
      _window.__cn_request_config.axiosConfig = _extends({}, _window.__cn_request_config.axiosConfig, axiosConfig);
    }
    var axiosInstance = CNRequest(_window.__cn_request_config.axiosConfig, _window.__cn_request_config.cnOptions);
    _window.__cn_request_instance.request = axiosInstance;
    return axiosInstance;
  }
};
var injectErrorMessage = function injectErrorMessage(responseData, requestInstance) {
  if (responseData === void 0) {
    responseData = {};
  }
  if (requestInstance === void 0) {
    requestInstance = {};
  }
  if (typeof Object.defineProperty === 'function') {
    var errorMessage = '';
    var getter = function getter() {
      // eslint-disable-next-line no-param-reassign
      requestInstance.__errorMessageReadCount = (Number(requestInstance.__errorMessageReadCount) || 0) + 1;
      return errorMessage;
    };
    if (typeof responseData.errorMsg === 'string') {
      errorMessage = responseData.errorMsg;
      Object.defineProperty(responseData, 'errorMsg', {
        get: getter
      });
    } else if (typeof responseData.msg === 'string') {
      errorMessage = responseData.msg;
      Object.defineProperty(responseData, 'msg', {
        get: getter
      });
    } else if (typeof responseData.message === 'string') {
      errorMessage = responseData.message;
      Object.defineProperty(responseData, 'message', {
        get: getter
      });
    } else if (responseData.error && typeof responseData.error.message === 'string') {
      errorMessage = responseData.error.message;
      Object.defineProperty(responseData.error, 'message', {
        get: getter
      });
    }
  }
};
function cnResponseInterceptor(response, armsTrace, options) {
  if (armsTrace === void 0) {
    armsTrace = null;
  }
  var _options$turnOffTrace = options.turnOffTrace,
    turnOffTrace = _options$turnOffTrace === void 0 ? true : _options$turnOffTrace,
    _options$turnOffLog = options.turnOffLog,
    turnOffLog = _options$turnOffLog === void 0 ? false : _options$turnOffLog,
    _options$reportRespon = options.reportResponse,
    reportResponse = _options$reportRespon === void 0 ? false : _options$reportRespon,
    _options$cnReportHand = options.cnReportHandler,
    cnReportHandler = _options$cnReportHand === void 0 ? function () {
      return false;
    } : _options$cnReportHand;
  var _ref = response.data,
    success = _ref.success,
    msg = _ref.msg,
    errorMsg = _ref.errorMsg,
    errorCode = _ref.errorCode,
    data = _ref.data;

  // 接口格式不符合规范日志打印
  if (!turnOffLog) {
    // 格式校验
    if (isUndefined(success) || isUndefined(msg) || isUndefined(errorMsg) || isUndefined(errorCode) || isUndefined(data)) {
      // eslint-disable-next-line no-console
      console.warn("\u63A5\u53E3\u8FD4\u56DE\u503C\u683C\u5F0F\u4E0D\u5408\u6CD5: " + response.request.responseURL);
      // eslint-disable-next-line no-console
      console.warn('Evil response.data:', response.data);
      // eslint-disable-next-line no-console
      console.warn('返回值格式规范请参照: https://yuque.antfin.com/docs/share/18c289e7-7cc9-46d5-aa31-891d18ba168c');
    }
  }

  // 是否上报数据
  var doReport = false;

  // 上报的业务数据
  var reportData = {
    errorCode: '-',
    errorMsg: '-',
    extend: undefined,
    reportResponse: reportResponse
  };

  // 符合规范的业务异常上报
  if (success === false) {
    doReport = true;
    reportData.errorCode = errorCode || '-';
    reportData.errorMsg = errorMsg || '-';

    // 请查阅：https://yuque.antfin-inc.com/docs/share/f62c2c51-4a27-4a83-8c9e-cecce5162be1?#r23Cu
    try {
      injectErrorMessage(response.data, response.request);
    } catch (error) {
      // do nothing
    }
  }

  // 应用级 自定义业务异常上报
  try {
    if (cnReportHandler instanceof Function) {
      var _reportData1 = cnReportHandler(response.data);
      if (_reportData1 instanceof Object) {
        doReport = true;
        reportData = mergeReportData(reportData, _reportData1);
      }
    }
  } catch (error) {
    // do nothing
  }

  // 接口级 自定义业务异常上报
  try {
    var _ref2 = response.config,
      _cnReportHandler = _ref2.cnReportHandler;
    if (_cnReportHandler instanceof Function) {
      var _reportData2 = _cnReportHandler(response.data);
      if (_reportData2 instanceof Object) {
        doReport = true;
        reportData = mergeReportData(reportData, _reportData2);
      }
    }
  } catch (error) {
    // do nothing
  }

  // 若符合上报条件，并且页面自身没有使用cone-arms包 则执行上报
  if (!turnOffTrace && doReport === true && armsTrace && typeof _window.coneArmsTrace !== 'object') {
    armsTraceLog(response, armsTrace, reportData);
  }
}
function cnRequestInterceptor(config, options) {
  var method = config.method.toUpperCase();
  var _options$turnOffLog2 = options.turnOffLog,
    turnOffLog = _options$turnOffLog2 === void 0 ? false : _options$turnOffLog2;
  if (!turnOffLog) {
    if (!LEGAL_METHODS.includes(method)) {
      // eslint-disable-next-line no-console
      console.warn("\u4F7F\u7528\u4E86\u4E0D\u88AB\u63A8\u8350\u7684\u8BF7\u6C42method\uFF1A" + method + "\uFF1B\u4EC5\u63A8\u8350 GET \u548C POST \u4E24\u79CD\u8BF7\u6C42method");
    }
  }
}

/**
 * 基于axios实现的菜鸟基础request库
 * @param {axiosConfig} AxiosRequestConfig 初始化axios实例的配置项
 * @param {cnOptions} CnOptions 菜鸟业务相关的参数
 * @return {AxiosInstance} axios实例，详细查看：https://axios-http.com/zh/docs/instance
 */
function CNRequest(axiosConfig, cnOptions) {
  if (axiosConfig === void 0) {
    axiosConfig = {};
  }
  if (cnOptions === void 0) {
    cnOptions = {};
  }
  var _cnOptions = cnOptions,
    _cnOptions$armsTrace = _cnOptions.armsTrace,
    armsTrace = _cnOptions$armsTrace === void 0 ? null : _cnOptions$armsTrace,
    _cnOptions$loginCallb = _cnOptions.loginCallback,
    loginCallback = _cnOptions$loginCallb === void 0 ? function () {} : _cnOptions$loginCallb,
    _cnOptions$turnOffTra = _cnOptions.turnOffTrace,
    turnOffTrace = _cnOptions$turnOffTra === void 0 ? true : _cnOptions$turnOffTra,
    _cnOptions$turnOffLog = _cnOptions.turnOffLog,
    turnOffLog = _cnOptions$turnOffLog === void 0 ? false : _cnOptions$turnOffLog,
    _cnOptions$reportResp = _cnOptions.reportResponse,
    reportResponse = _cnOptions$reportResp === void 0 ? false : _cnOptions$reportResp,
    _cnOptions$cnReportHa = _cnOptions.cnReportHandler,
    cnReportHandler = _cnOptions$cnReportHa === void 0 ? function () {
      return false;
    } : _cnOptions$cnReportHa,
    _cnOptions$feedbackIn = _cnOptions.feedbackInfoEnabled,
    feedbackInfoEnabled = _cnOptions$feedbackIn === void 0 ? false : _cnOptions$feedbackIn;
  var logOptions = {
    turnOffTrace: turnOffTrace,
    turnOffLog: turnOffLog,
    reportResponse: reportResponse,
    cnReportHandler: cnReportHandler
  };
  var axiosInstance = axios.create(axiosConfig);

  // axios默认会加
  // 全局 xsrfToken 处理
  // try {
  //   const xsrfToken = getCookie("XSRF-TOKEN");
  //   if (xsrfToken) {
  //     axiosInstance.defaults.headers.common["X-XSRF-TOKEN"] = xsrfToken;
  //   }
  // } catch (error) {}

  axiosInstance.interceptors.request.use(function (config) {
    try {
      cnRequestInterceptor(config, logOptions);
    } catch (err) {
      // eslint-disable-next-line no-param-reassign
      console.error("cnRequestInterceptor\u51FA\u9519:", err);
    }
    return config;
  }, function (error) {
    return Promise.reject(error);
  });
  axiosInstance.interceptors.response.use(function (response) {
    var _response$data$errorC = response.data.errorCode,
      errorCode = _response$data$errorC === void 0 ? '' : _response$data$errorC;
    try {
      cnResponseInterceptor(response, armsTrace, logOptions);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error("cnResponseInterceptor\u51FA\u9519:", err);
    }
    // 未登录执行登录回调
    if (errorCode === '1000') {
      try {
        loginCallback();
      } catch (error) {
        // do nothing
      }
    }
    return response;
  }, function (error) {
    return Promise.reject(error);
  });
  if (feedbackInfoEnabled === true) {
    axiosInstance.interceptors.response.use(errorFeedbackInterceptor);
  }
  return axiosInstance;
}
function request(options) {
  // _window.__cn_request_instance.request 未初始化 则 初始化一次
  if (!_window.__cn_request_instance.request) {
    var axiosInstance = CNRequest(_window.__cn_request_config.axiosConfig, _window.__cn_request_config.cnOptions);
    axiosInstance.interceptors.response.use(function (response) {
      var _ref3 = response.data || {},
        _ref3$success = _ref3.success,
        success = _ref3$success === void 0 ? undefined : _ref3$success;
      if (success === true) {
        return response;
      } else {
        return Promise.reject(response);
      }
    }, function (err) {
      return Promise.reject(err);
    });
    _window.__cn_request_instance.request = axiosInstance;
  }
  return _window.__cn_request_instance.request(options);
}
function getRequest() {
  return _window.__cn_request_instance.request;
}
var cnRequestInstance = _window.__cn_request_instance;
var CancelToken = axios.CancelToken;
export { CancelToken, cnResponseInterceptor, cnRequestInterceptor, cnRequestInstance, request, getRequest };
export default CNRequest;